import { useQuery } from "react-query";
import {
    getSteamActivitySeries,
    getSteamCommunity,
    getSteamCompletionSeries,
    getSteamInsightMetrics,
    getSteamNextPlay,
    getSteamUnplayed,
} from "../../../api/steam";

// Marts rebuild once a day, so cached results stay valid for a while
const STALE_TIME = 10 * 60 * 1000;

const options = { staleTime: STALE_TIME, keepPreviousData: true };

export const useInsightMetrics = () =>
    useQuery("steamInsightMetrics", () => getSteamInsightMetrics().then((r) => r.data), {
        staleTime: Infinity,
    });

export const useCompletionSeries = (metric, grain) =>
    useQuery(
        ["steamCompletionSeries", metric, grain],
        () => getSteamCompletionSeries(metric, grain).then((r) => r.data),
        { ...options, enabled: Boolean(metric && grain) }
    );

export const useActivitySeries = (grain) =>
    useQuery(
        ["steamActivitySeries", grain],
        () => getSteamActivitySeries(grain).then((r) => r.data),
        { ...options, enabled: Boolean(grain) }
    );

export const useNextPlay = (limit = 10) =>
    useQuery(["steamNextPlay", limit], () => getSteamNextPlay(limit).then((r) => r.data.games), options);

export const useUnplayed = () =>
    useQuery("steamUnplayed", () => getSteamUnplayed().then((r) => r.data.games), options);

export const useCommunity = () =>
    useQuery("steamCommunity", () => getSteamCommunity().then((r) => r.data.games), options);
